import {Injectable} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {MatDialog} from '@angular/material/dialog';
import {DataEntity} from 'octopus-connect';
import {NpsComponent} from 'fuse-core/components/nps/nps.component';

@Injectable({
    providedIn: 'root'
})
export class NpsPromptService {
    private readonly npsLastAskStorageKey = 'nps_last_ask';

    constructor(
        private platform: Platform,
        private bottomSheet: MatBottomSheet,
        private dialog: MatDialog
    ) {}

    public shouldDisplayNps(params: {
        currentUrl: string;
        expectedUrl: string;
        isNpsEnabled: boolean;
        userData: DataEntity;
    }): boolean {
        const now = new Date();
        const localStorageDate = localStorage.getItem(this.npsLastAskStorageKey);

        return params.currentUrl === params.expectedUrl
            && params.isNpsEnabled
            && params.userData.get('displayNps')
            && (!localStorageDate || localStorageDate !== now.toDateString());
    }

    public tryOpenNps(params: {
        currentUrl: string;
        expectedUrl: string;
        isNpsEnabled: boolean;
        userData: DataEntity;
    }): void {
        if (!this.shouldDisplayNps(params)) {
            return;
        }

        this.openNps(params.userData);
    }

    public openNps(userData: DataEntity): void {
        const now = new Date();
        const onNpsClosed = (): void => localStorage.setItem(this.npsLastAskStorageKey, now.toDateString());

        if (this.platform.ANDROID || this.platform.IOS) {
            this.bottomSheet.open(NpsComponent, {
                data: {
                    uid: userData.id,
                    type: 'bottomSheet',
                },
                panelClass: 'nps-bottom-sheet-wrapper',
            }).afterDismissed().subscribe(onNpsClosed);
            return;
        }

        this.dialog.open(NpsComponent, {
            data: {
                uid: userData.id,
                type: 'dialog',
            },
            panelClass: 'nps-dialog-wrapper',
        }).afterClosed().subscribe(onNpsClosed);
    }
}
